import { useQuery } from "@tanstack/react-query";
import { getAllDepartments } from "../../api/apiDepartments";
import i18next from "i18next";

export function useGetDepartments(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["departments", page, perPage, filters, i18next.language],
        queryFn: () => getAllDepartments(page, perPage, filters),
        retry: false,
    });

    const departments = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, departments, meta };
}
